export const isDevEnv = () => window.location.hostname === 'localhost';
